var _style, _g, _g2, _defs, _rect, _text, _rect2, _text2, _rect3, _text3, _rect4, _text4, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D6D6D6;}\n\t.st1{opacity:0.33;}\n\t.st2{fill:#6A8AAF;stroke:#6A8AAF;stroke-miterlimit:10;}\n\t.st3{opacity:0.42;}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000117671188119636961660000004613499038492546452_);fill:#486290;stroke:#486290;stroke-width:0.75;stroke-miterlimit:10;}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000117671188119636961660000004613499038492546452_);fill:none;stroke:#486290;stroke-width:0.75;stroke-miterlimit:10;}\n\t.st6{fill:none;}\n\t.st7{font-family:'SourceSansPro-SemiBold';}\n\t.st8{font-size:7px;}\n\t.st9{font-size:8px;}\n\t.st10{font-size:9px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.98,288H20.02C8.96,288,0,279.04,0,267.98V20.02C0,8.96,8.96,0,20.02,0h247.97 C279.04,0,288,8.96,288,20.02v247.97C288,279.04,279.04,288,267.98,288z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M160.03,274.6c0-0.84-0.69-1.53-1.55-1.53c-0.86,0-1.55,0.68-1.55,1.53c0,0.84,0.69,1.53,1.55,1.53 C159.34,276.12,160.03,275.44,160.03,274.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.33,259.06c0-1.26-1.04-2.28-2.32-2.28c-1.28,0-2.32,1.02-2.32,2.28c0,1.26,1.04,2.28,2.32,2.28 C62.29,261.34,63.33,260.32,63.33,259.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.51,210.51c0-0.96-0.79-1.74-1.77-1.74c-0.98,0-1.77,0.78-1.77,1.74c0,0.96,0.79,1.74,1.77,1.74 C21.72,212.25,22.51,211.47,22.51,210.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107.73,176.27c0-1.41-1.16-2.55-2.59-2.55c-1.43,0-2.59,1.14-2.59,2.55c0,1.41,1.16,2.55,2.59,2.55 C106.57,178.82,107.73,177.68,107.73,176.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97,141.31c0-0.34-0.28-0.61-0.62-0.61c-0.34,0-0.62,0.28-0.62,0.61c0,0.34,0.28,0.61,0.62,0.61 C96.72,141.92,97,141.65,97,141.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.22,124.77c0-1.15-0.94-2.08-2.11-2.08c-1.17,0-2.11,0.93-2.11,2.08c0,1.15,0.95,2.08,2.11,2.08 C12.27,126.85,13.22,125.92,13.22,124.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.78,109.1c0-1.18-0.97-2.13-2.16-2.13c-1.19,0-2.16,0.95-2.16,2.13c0,1.18,0.97,2.13,2.16,2.13 C121.81,111.23,122.78,110.28,122.78,109.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.72,64.06c0-0.95-0.78-1.72-1.75-1.72c-0.96,0-1.75,0.77-1.75,1.72c0,0.95,0.78,1.72,1.75,1.72 C66.93,65.78,67.72,65.01,67.72,64.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.77,74.49c0-1.37-1.13-2.48-2.52-2.48c-1.39,0-2.52,1.11-2.52,2.48c0,1.37,1.13,2.48,2.52,2.48 C24.65,76.97,25.77,75.86,25.77,74.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M5.54,21.49c0-0.58-0.47-1.04-1.06-1.04c-0.58,0-1.06,0.47-1.06,1.04c0,0.58,0.47,1.04,1.06,1.04 C5.07,22.54,5.54,22.07,5.54,21.49z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 158,
    y1: 274.6,
    x2: 61.62,
    y2: 259.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 60.32,
    y1: 259.06,
    x2: 20.74,
    y2: 210.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 20.74,
    y1: 210.51,
    x2: 104.08,
    y2: 176.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 104.69,
    y1: 175.21,
    x2: 96.37,
    y2: 141.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 96.37,
    y1: 141.31,
    x2: 11.11,
    y2: 124.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11.11,
    y1: 124.77,
    x2: 120.62,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 120.09,
    y1: 109.1,
    x2: 65.97,
    y2: 64.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 65.97,
    y1: 64.06,
    x2: 23.26,
    y2: 74.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 23.26,
    y1: 75.06,
    x2: 4.48,
    y2: 21.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 4.48,
    y1: 21.05,
    x2: 5.54,
    y2: -25.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 158.48,
    y1: 274.6,
    x2: 157.49,
    y2: 293.74
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.07,194.31c0-1.05-0.86-1.9-1.92-1.9c-1.06,0-1.92,0.85-1.92,1.9c0,1.05,0.86,1.9,1.92,1.9 C78.21,196.21,79.07,195.36,79.07,194.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.7,164.81c0-0.48-0.4-0.87-0.89-0.87c-0.49,0-0.89,0.39-0.89,0.87c0,0.48,0.4,0.87,0.89,0.87 C13.3,165.68,13.7,165.29,13.7,164.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.89,92.75c0-1.24-1.02-2.24-2.27-2.24c-1.25,0-2.27,1-2.27,2.24c0,1.24,1.02,2.24,2.27,2.24 C56.87,94.99,57.89,93.99,57.89,92.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.79,73.49c0-1.68-1.39-3.05-3.1-3.05c-1.71,0-3.1,1.36-3.1,3.05c0,1.68,1.39,3.05,3.1,3.05 C138.4,76.54,139.79,75.17,139.79,73.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M49.27,278.47c0-1.66-1.37-3.01-3.05-3.01c-1.69,0-3.05,1.35-3.05,3.01c0,1.66,1.37,3.01,3.05,3.01 C47.9,281.48,49.27,280.13,49.27,278.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.58,254.27c0-1.22-1-2.2-2.23-2.2c-1.23,0-2.23,0.99-2.23,2.2c0,1.22,1,2.2,2.23,2.2 C130.58,256.47,131.58,255.48,131.58,254.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M161.03,211.76c0-0.69-0.57-1.25-1.27-1.25c-0.7,0-1.27,0.56-1.27,1.25c0,0.69,0.57,1.25,1.27,1.25 C160.46,213.02,161.03,212.46,161.03,211.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.61,28.84c0-0.72-0.59-1.3-1.32-1.3c-0.73,0-1.32,0.58-1.32,1.3c0,0.72,0.59,1.3,1.32,1.3 C94.02,30.14,94.61,29.55,94.61,28.84z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.22,
    y1: 278.47,
    x2: -84.95,
    y2: 265.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 46.22,
    y1: 278.47,
    x2: 129.34,
    y2: 254.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 129.34,
    y1: 254.27,
    x2: 159.76,
    y2: 211.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 159.76,
    y1: 211.76,
    x2: 77.15,
    y2: 194.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 77.15,
    y1: 194.31,
    x2: 12.81,
    y2: 164.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 12.81,
    y1: 164.81,
    x2: 55.62,
    y2: 92.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 55.62,
    y1: 92.75,
    x2: 136.69,
    y2: 73.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 136.69,
    y1: 73.49,
    x2: 93.29,
    y2: 28.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 93.29,
    y1: 28.84,
    x2: 112.31,
    y2: -17.82
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -0.68,
    y: -0.78,
    width: 289.32,
    height: 289.32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162333797708228472040000016592069418511838873_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M59.63,175.23c0-2.02-1.63-3.65-3.65-3.65c-2.01,0-3.65,1.63-3.65,3.65c0,2.01,1.63,3.65,3.65,3.65 C58,178.88,59.63,177.25,59.63,175.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M132.05,139.68c0-0.54-0.44-0.99-0.99-0.99s-0.99,0.44-0.99,0.99s0.44,0.99,0.99,0.99S132.05,140.23,132.05,139.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M172.76,253.45c0-2.31-1.87-4.19-4.19-4.19c-2.31,0-4.19,1.87-4.19,4.19c0,2.31,1.87,4.19,4.19,4.19 C170.88,257.64,172.76,255.77,172.76,253.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M59.12,51.64c0-12.97-10.51-23.48-23.48-23.48c-12.97,0-23.48,10.51-23.48,23.48s10.51,23.48,23.48,23.48 C48.61,75.12,59.12,64.6,59.12,51.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "none",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M192.89,69.51c0-17.27-13.99-31.26-31.27-31.26c-17.27,0-31.26,13.99-31.26,31.26c0,17.27,13.99,31.26,31.26,31.26 C178.9,100.78,192.89,86.78,192.89,69.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "none",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M95.65,221.1c0-15.64-12.67-28.31-28.32-28.31c-15.64,0-28.31,12.67-28.31,28.31c0,15.64,12.67,28.31,28.31,28.31 C82.98,249.42,95.65,236.74,95.65,221.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M215.77,214.91c0-0.72-0.58-1.3-1.3-1.3c-0.72,0-1.3,0.58-1.3,1.3c0,0.72,0.58,1.3,1.3,1.3 C215.18,216.22,215.77,215.63,215.77,214.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M102.41,229.82c0-0.63-0.51-1.15-1.15-1.15c-0.63,0-1.15,0.51-1.15,1.15c0,0.63,0.51,1.15,1.15,1.15 C101.89,230.97,102.41,230.45,102.41,229.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M65.21,23.16c0-0.63-0.51-1.15-1.15-1.15c-0.63,0-1.15,0.51-1.15,1.15c0,0.63,0.51,1.15,1.15,1.15 C64.7,24.31,65.21,23.79,65.21,23.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M119.92,264.68c0-0.63-0.51-1.15-1.15-1.15c-0.63,0-1.15,0.51-1.15,1.15c0,0.63,0.51,1.15,1.15,1.15 C119.41,265.82,119.92,265.31,119.92,264.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M89.96,97.84c0-0.91-0.74-1.65-1.65-1.65c-0.91,0-1.65,0.74-1.65,1.65c0,0.91,0.74,1.65,1.65,1.65 C89.23,99.49,89.96,98.75,89.96,97.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M232.46,273.43c0-0.91-0.74-1.65-1.65-1.65c-0.91,0-1.65,0.74-1.65,1.65c0,0.91,0.74,1.65,1.65,1.65 C231.73,275.07,232.46,274.34,232.46,273.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M29.71,195.93c0-0.91-0.74-1.65-1.65-1.65c-0.91,0-1.65,0.74-1.65,1.65c0,0.91,0.74,1.65,1.65,1.65 C28.98,197.58,29.71,196.85,29.71,195.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M175.87,180.75c0-15.53-12.58-28.11-28.11-28.11c-15.53,0-28.12,12.58-28.12,28.11c0,15.52,12.59,28.11,28.12,28.11 C163.29,208.86,175.87,196.27,175.87,180.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M272.31,270.31c0-1.27-1.03-2.29-2.29-2.29c-1.27,0-2.29,1.03-2.29,2.29c0,1.27,1.03,2.29,2.29,2.29 C271.29,272.6,272.31,271.57,272.31,270.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M115.74,12.37c0-1.75-1.42-3.16-3.16-3.16c-1.75,0-3.16,1.42-3.16,3.16c0,1.75,1.42,3.16,3.16,3.16 C114.32,15.53,115.74,14.12,115.74,12.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M24.27,240.84c0-1.79-1.45-3.25-3.25-3.25c-1.79,0-3.25,1.45-3.25,3.25c0,1.79,1.45,3.25,3.25,3.25 C22.82,244.09,24.27,242.64,24.27,240.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M85.82,281.62c0-1.47-1.19-2.66-2.66-2.66c-1.47,0-2.66,1.19-2.66,2.66c0,1.47,1.19,2.66,2.66,2.66 C84.63,284.28,85.82,283.09,85.82,281.62z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 23.27,
    y1: 242.22,
    x2: 80.95,
    y2: 280.16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 85.27,
    y1: 280.72,
    x2: 118.14,
    y2: 264.96
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 119.56,
    y1: 264.68,
    x2: 164.98,
    y2: 254.25
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 171.72,
    y1: 254.86,
    x2: 229.93,
    y2: 273.43
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 231.86,
    y1: 273.43,
    x2: 268.77,
    y2: 270.31
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 230.82,
    y1: 272.6,
    x2: 214.46,
    y2: 214.91
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 170.5,
    y1: 251.26,
    x2: 214.46,
    y2: 214.91
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 118.77,
    y1: 264.26,
    x2: 101.71,
    y2: 229.82
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 94.57,
    y1: 228.83,
    x2: 100.69,
    y2: 229.82
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 22.66,
    y1: 239.8,
    x2: 41.53,
    y2: 232.78
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 21.49,
    y1: 238.82,
    x2: 28.07,
    y2: 196.65
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 28.59,
    y1: 195.49,
    x2: 54.21,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 59.46,
    y1: 193.9,
    x2: 55.98,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 58.52,
    y1: 175.8,
    x2: 119.71,
    y2: 182.62
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 171.18,
    y1: 196.3,
    x2: 213.86,
    y2: 214.91
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 136.26,
    y1: 155.09,
    x2: 131.52,
    y2: 140.11
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 89.09,
    y1: 98.58,
    x2: 131.07,
    y2: 139.68
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 53.27,
    y1: 66.58,
    x2: 87.74,
    y2: 97.41
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 52.01,
    y1: 34.8,
    x2: 63.65,
    y2: 23.16
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 64.46,
    y1: 23.16,
    x2: 110.49,
    y2: 13.09
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 113.81,
    y1: 14.53,
    x2: 141.93,
    y2: 45.23
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 133.11,
    y1: 82.34,
    x2: 89.09,
    y2: 97.41
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 131.07,
    y1: 139.68,
    x2: 148.35,
    y2: 97.82
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 64.07,
    y1: 23.16,
    x2: 88.32,
    y2: 97.84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 64.07,
    y1: 23.16,
    x2: 133.33,
    y2: 56.21
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 55.98,
    y1: 175.23,
    x2: 88.32,
    y2: 97.61
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 21.03,
    y1: 240.84,
    x2: -20.57,
    y2: 124.08
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 28.07,
    y1: 195.93,
    x2: -20.57,
    y2: 124.08
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 55.98,
    y1: 175.23,
    x2: -20.57,
    y2: 124.08
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 88.32,
    y1: 97.84,
    x2: -20.57,
    y2: 124.08
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 20.51,
    y1: 69.59,
    x2: -20.64,
    y2: 124.23
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 73.1,
    y1: 248.83,
    x2: 83.16,
    y2: 280.72
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 83.16,
    y1: 281.62,
    x2: 101.26,
    y2: 229.82
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 21.49,
    y1: 240.84,
    x2: 118.77,
    y2: 264.68
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 101.26,
    y1: 229.82,
    x2: 166.22,
    y2: 252.76
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 28.59,
    y1: 195.93,
    x2: 42.85,
    y2: 206.88
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 93.57,
    y1: 210.46,
    x2: 124.02,
    y2: 195.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 101.26,
    y1: 229.82,
    x2: 129.2,
    y2: 201.86
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 154.56,
    y1: 208.03,
    x2: 167.93,
    y2: 252.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 214.46,
    y1: 214.91,
    x2: 270.02,
    y2: 269.73
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 40.43,
    y1: 28.65,
    x2: 54.21,
    y2: -33.41
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 64.07,
    y1: 23.16,
    x2: 54.21,
    y2: -33.41
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 112.15,
    y1: 12.37,
    x2: 54.21,
    y2: -33.41
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 214.46,
    y1: 214.91,
    x2: 316.55,
    y2: 226.9
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 270.02,
    y1: 270.31,
    x2: 316.55,
    y2: 226.9
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 230.82,
    y1: 273.43,
    x2: 315.26,
    y2: 228.09
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 138.71,
    y1: 48.25,
    x2: 54.21,
    y2: -33.41
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 55.98,
    y1: 175.23,
    x2: 131.52,
    y2: 139.44
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 55.98,
    y1: 175.23,
    x2: 39.47,
    y2: 74.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 131.07,
    y1: 139.88,
    x2: -20.64,
    y2: 124.23
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 118.77,
    y1: 264.68,
    x2: 138.25,
    y2: 207.21
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 55.98,
    y1: 175.23,
    x2: 167.93,
    y2: 252.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 20.27,
    y1: 240.84,
    x2: 54.21,
    y2: 175.8
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 20.27,
    y1: 240.84,
    x2: -30.38,
    y2: 373.36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 83.16,
    y1: 281.62,
    x2: -30.38,
    y2: 373.36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 51.94,
    y1: 244.86,
    x2: -30.38,
    y2: 373.36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 168.57,
    y1: 253.45,
    x2: -30.38,
    y2: 373.36
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 118.77,
    y1: 264.68,
    x2: 213.16,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 168.57,
    y1: 253.45,
    x2: 213.16,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 230.82,
    y1: 273.43,
    x2: 213.16,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 270.02,
    y1: 270.31,
    x2: 213.16,
    y2: 307.1
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 168.57,
    y1: 253.45,
    x2: 316.55,
    y2: 226.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M55.98,175.23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    d: " M83.16,281.62"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 128.93,
    y1: 159.88,
    x2: 88.32,
    y2: 97.84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 58.98,
    y1: 54.2,
    x2: 130.73,
    y2: 64.72
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 88.32,
    y1: 97.84,
    x2: 112.15,
    y2: 12.37
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 76.83,
    y1: 194.42,
    x2: 120.51,
    y2: 187.67
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 50.85,
    y1: 69.52,
    x2: 126.6,
    y2: 162.24
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 101.26,
    y1: 229.97,
    x2: 88.32,
    y2: 97.84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 214.46,
    y1: 214.91,
    x2: 101.25,
    y2: 229.82
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 269.33,
    y1: 270.31,
    x2: 171.72,
    y2: 254.25
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 101.26,
    y1: 229.97,
    x2: 87.51,
    y2: 240.97
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 118.77,
    y1: 264.68,
    x2: 87.51,
    y2: 240.97
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 83.16,
    y1: 281.62,
    x2: 167.93,
    y2: 253.84
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 20.27,
    y1: 240.84,
    x2: -35.52,
    y2: 244.31
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 28.07,
    y1: 195.93,
    x2: -35.52,
    y2: 244.31
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 83.16,
    y1: 281.62,
    x2: -35.52,
    y2: 244.31
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 63.65,
    y1: 23.16,
    x2: -39.26,
    y2: 14.53
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 112.15,
    y1: 12.37,
    x2: -39.26,
    y2: 14.53
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 14.84,
    y1: 40.74,
    x2: -39.26,
    y2: 14.53
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 88.15,
    y1: 98.01,
    x2: 47.92,
    y2: 71.65
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 55.98,
    y1: 175.23,
    x2: -39.26,
    y2: 14.53
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 120.22,
    y1: 175.9,
    x2: -20.64,
    y2: 124.23
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 167.67,
    y1: 200.59,
    x2: 269.33,
    y2: 270.31
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 230.82,
    y1: 273.43,
    x2: 163.5,
    y2: 204.05
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 230.82,
    y1: 273.43,
    x2: 252.78,
    y2: 314.17
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 168.57,
    y1: 253.45,
    x2: 252.78,
    y2: 314.17
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 252.78,
    y1: 314.17,
    x2: 270.02,
    y2: 270.31
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 214.82,
    y1: 215.26,
    x2: 252.78,
    y2: 314.17
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 83.91,
    y1: 280.86,
    x2: 133.16,
    y2: 204.77
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 64.66,
    y1: 23.44,
    x2: 131.08,
    y2: 139.65
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      clipPath: "url(#SVGID_00000162333797708228472040000016592069418511838873_)",
      fill: "#486290",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    },
    x1: 112.7,
    y1: 12.37,
    x2: 131.24,
    y2: 139.68
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "none",
      stroke: "#486290",
      strokeWidth: 0.75,
      strokeMiterlimit: 10
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.14,
    y: 31.98,
    className: "st6",
    width: 40.48,
    height: 48.09
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 25.3984 36.9213)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st8"
  }, "Access  "), /*#__PURE__*/React.createElement("tspan", {
    x: -0.09,
    y: 8.4,
    className: "st7 st8"
  }, "Health "), /*#__PURE__*/React.createElement("tspan", {
    x: -5.71,
    y: 16.8,
    className: "st7 st8"
  }, "Insights at "), /*#__PURE__*/React.createElement("tspan", {
    x: 1.38,
    y: 25.2,
    className: "st7 st8"
  }, "home "), /*#__PURE__*/React.createElement("tspan", {
    x: -2.43,
    y: 33.6,
    className: "st7 st8"
  }, "anytime"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.16,
    y: 198.5,
    className: "st6",
    width: 40.48,
    height: 48.09
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 56.3614 204.1465)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st9"
  }, "Utilize "), /*#__PURE__*/React.createElement("tspan", {
    x: -9.12,
    y: 9.6,
    className: "st7 st9"
  }, "data-driven "), /*#__PURE__*/React.createElement("tspan", {
    x: -6.38,
    y: 19.2,
    className: "st7 st9"
  }, "predictive "), /*#__PURE__*/React.createElement("tspan", {
    x: -1.83,
    y: 28.8,
    className: "st7 st9"
  }, "disease "), /*#__PURE__*/React.createElement("tspan", {
    x: -2.88,
    y: 38.4,
    className: "st7 st9"
  }, "analysis"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 127.59,
    y: 159.22,
    className: "st6",
    width: 40.48,
    height: 54.38
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 134.4403 164.8644)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st9"
  }, "Identify "), /*#__PURE__*/React.createElement("tspan", {
    x: 7.3,
    y: 9.6,
    className: "st7 st9"
  }, "key "), /*#__PURE__*/React.createElement("tspan", {
    x: -3.34,
    y: 19.2,
    className: "st7 st9"
  }, "biometric "), /*#__PURE__*/React.createElement("tspan", {
    x: -5.99,
    y: 28.8,
    className: "st7 st9"
  }, "data in real "), /*#__PURE__*/React.createElement("tspan", {
    x: 5.5,
    y: 38.4,
    className: "st7 st9"
  }, "time"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 133.86,
    y: 45.46,
    className: "st6",
    width: 54.34,
    height: 53.13
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 145.0819 51.8147)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st7 st10"
  }, "Perform "), /*#__PURE__*/React.createElement("tspan", {
    x: -2.98,
    y: 10.8,
    className: "st7 st10"
  }, "quick and "), /*#__PURE__*/React.createElement("tspan", {
    x: 0.02,
    y: 21.6,
    className: "st7 st10"
  }, "efficient "), /*#__PURE__*/React.createElement("tspan", {
    x: 2.57,
    y: 32.4,
    className: "st7 st10"
  }, "guided"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.55,
    y: 43.2,
    className: "st7 st10"
  }, " exams")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAi);
export default __webpack_public_path__ + "static/media/infoAI.5a6155b3bb7ee71a6354acc89a4f02ed.svg";
export { ForwardRef as ReactComponent };